import { render, staticRenderFns } from "./CatalogCard.vue?vue&type=template&id=fe60f05a&scoped=true&"
import script from "./CatalogCard.vue?vue&type=script&lang=js&"
export * from "./CatalogCard.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCard.vue?vue&type=style&index=0&id=fe60f05a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe60f05a",
  null
  
)

export default component.exports